module.exports = __webpack_public_path__ + "static/grafika5@2x-d766aa56a3880adc8ae523e6c7f7c53f.png";